import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: any,
        private snackBar: MatSnackBar
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

        let token = null;
        if (isPlatformBrowser(this.platformId)) {
            const localToken = localStorage.getItem('userToken');
            const sessionToken = sessionStorage.getItem('userToken');
            token = localToken ? localToken : sessionToken ? sessionToken : null;
        }

        // console.log(route);

        if (token) {
            return true;
        }

        this.snackBar.open(
            'Unauthorized!', 'Close',
            {
                horizontalPosition: 'end',
                verticalPosition: 'bottom',
                duration: 1000
            }
        );

        this.router.navigate(['/']);
        return false;
    }

    private handleUnAuthorized(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.clear();
            sessionStorage.clear();
            // this.commonSandbox.doSignout();
            // this.router.navigate(['/']);
        }
    }
}

